import { useReducer } from 'react';

type UseSelectedTimesAction = {
    type: 'reset' | 'toggle' | 'select' | 'deselect';
    times: Date[];
};

/**
 * Reducer dispatch for an array of Date objects, to toggle times on or off and reset the full array
 */
const selectedTimesDispatch = (selectedTimes: Date[], action: UseSelectedTimesAction) => {
    switch (action.type) {
        case 'toggle':
            return action.times.reduce((acc, time) => {
                if (acc.some(selectedTime => selectedTime.getTime() === time.getTime())) {
                    return acc.filter(selectedTime => selectedTime.getTime() !== time.getTime());
                } else {
                    return [...acc, time];
                }
            }, selectedTimes);
        case 'select':
            return action.times.reduce((acc, time) => {
                if (acc.some(selectedTime => selectedTime.getTime() === time.getTime())) {
                    return acc;
                } else {
                    return [...acc, time];
                }
            }, selectedTimes);
        case 'deselect':
            return selectedTimes.filter(
                selectedTime =>
                    !action.times.some(time => selectedTime.getTime() === time.getTime())
            );
        case 'reset':
            return action.times;
        default:
            throw new Error(`Invalid useSelectedTimes dispatch type`);
    }
};

/**
 * Hook for managing an array of Date objects, with a dispatch function to toggle times on or off and set the full array
 */
export const useTimesSelectionArray = (initialValue: Date[] = []) =>
    useReducer(selectedTimesDispatch, initialValue);
